module.exports = __webpack_public_path__ + "static/media/PKMimageTemp.109be41f.jpg";